var chunkToChildrenMap = {
	"1003": [
		3700,
		3166,
		4482
	],
	"1189": [
		3700,
		3166,
		4482
	],
	"5383": [
		3700,
		3166,
		4482
	],
	"6642": [
		3700,
		3166,
		4482
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };